export default {"src":"https://webcdn.trailways.com/_next/static/media/toggle-off.155c11f8.svg","height":44,"width":57,"blurWidth":0,"blurHeight":0};